import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/optimizer/guide.json',
  fetchTags: 'mock-data/optimizer/tags_cat.json',
  fetchArtefacts: 'mock-data/optimizer/artefacts.json',
  fetchArtefact: 'mock-data/optimizer/artefact.json',
  fetchArtifactUnit: 'mock-data/optimizer/artefactUnit.json',
  trend_cpo: 'mock-data/optimizer/trend.json',
  recommend_cpo: 'mock-data/optimizer/recommend.json',
  bundle_cpo: 'mock-data/optimizer/bundle-recommend.json',

  // spo: apiDlUrl+'appstoreskuorder',
  sst_mock: 'mock-data/optimizer/trend_sku.json',
  sdt_mock: 'mock-data/optimizer/trend_cat.json',
  spo_mock: 'mock-data/optimizer/recommend_cat.json',
};
